module.exports = __webpack_public_path__ + "static/media/pranita.e06ff6a5.jpeg";